// extracted by mini-css-extract-plugin
export var advisorsSection = "index-module--advisorsSection--VKpvG";
export var advisorsSectionContainer = "index-module--advisorsSectionContainer---HEZ+";
export var advisorsSectionTitle = "index-module--advisorsSectionTitle--Zbx-y";
export var advisorsSectionSubtitle = "index-module--advisorsSectionSubtitle--Rvgnw";
export var cardHeader = "index-module--cardHeader--45RQ+";
export var cardText = "index-module--cardText--ktO4t";
export var cardImageWrap = "index-module--cardImageWrap--ucI3J";
export var cardImage = "index-module--cardImage--i5RMP";
export var container = "index-module--container--iUdjq";
export var leftContainer = "index-module--leftContainer--RHvkq";
export var cardContainer = "index-module--cardContainer--28OLc";
export var flipped = "index-module--flipped--3YygC";
export var cardContainerBg = "index-module--cardContainerBg--JlCH6";
export var socialButtonsWrap = "index-module--socialButtonsWrap--mSICx";
export var rightContainer = "index-module--rightContainer--6Wmnp";